export const useSupportedLangCodes = () => {
  const config = useRuntimeConfig()
  const codes = config.public.i18n.locales.map((locale: { code: string, premiumId: number }) => locale.code)

  const validate = (lang: string) => {
    return codes.includes(lang)
  }

  return { codes, validate }
}
